import { TextField } from "@mui/material";
import SystemSettingsStagingDiversion from "../../../SystemSettingsStagingDiversion/SystemSettingsStagingDiversion";
import type { EmrStagingIntegrationFormProps } from "./EmrStagingIntegrationForm.types";
import { isRoleArn } from "./EmrStagingIntegrationForm.utils";

export default function EmrStagingIntegrationForm({
  entry,
  onChange,
}: EmrStagingIntegrationFormProps) {
  const patchEntry = (patch: Partial<EmrStagingIntegrationFormProps["entry"]>) =>
    onChange({ ...entry, ...patch });

  const roleArnInvalid =
    !!entry.runner_role_arn.trim() && !isRoleArn(entry.runner_role_arn);

  return (
    <>
      <TextField
        label="Runner role ARN"
        placeholder="arn:aws:iam::123456789012:role/definity-runner"
        value={entry.runner_role_arn}
        onChange={(e) => patchEntry({ runner_role_arn: e.target.value })}
        error={roleArnInvalid}
        helperText={
          roleArnInvalid
            ? "Must be an IAM role ARN (arn:aws:iam::<account-id>:role/<name>)"
            : "ARN of the runner role you created for staging runs"
        }
        fullWidth
        required
        size="small"
      />
      <SystemSettingsStagingDiversion
        value={entry}
        onChange={patchEntry}
        scheme="s3://"
      />
    </>
  );
}
